export const HIDE_SCROLLBAR_CLASS = '--hide-scrollbar'
export const DISABLE_SELECTION_CLASS = '--no-select'
export const FULLSCREEN_ELEMENT_CLASS = '--fullscreen-mode'

export const CUSTOM_SCROLL_CLASS = 'scroller'
